import { useEffect, useState } from "react";
import { Card, Descriptions } from "antd";
import "./index.css";
import moment from "moment";

const PendingComponent = (props) => {
  const initialCountdown = 10;
  const [countdown, setCountdown] = useState(
    Number(localStorage.getItem("countdown")) || initialCountdown
  );
  useEffect(() => {
    const timerInterval = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown <= 1) {
          clearInterval(timerInterval);
          localStorage.removeItem("countdown");
          return 0;
        }
        const newCountdown = prevCountdown - 1;
        localStorage.setItem("countdown", newCountdown);
        return newCountdown;
      });
    }, 1000);
    return () => clearInterval(timerInterval);
  }, []);

  const toSentenceCase = (str) => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      const data = {
        merchantid: props.transaction_data?.merchantid,
        txnid: props.transaction_data?.txnid,
        gstin: props.transaction_data?.GSTIN,
        cpin: props.transaction_data?.CPIN,
        total_amt: props.transaction_data?.Amount,
        igst_amt: props.transaction_data?.IGST_Amount,
        sgst_amt: props.transaction_data?.SGST_Amount,
        cgst_amt: props.transaction_data?.CGST_Amount,
        cess_amt: props.transaction_data?.CESS_Amount,
        beneficiary_state_cd: props.transaction_data?.beneficiary_state_cd,
        request_tim: props.transaction_data?.request_tim,
        returnurl: props.transaction_data?.returnurl,
        chln_exp_dt: props.transaction_data?.chln_exp_dt,
        igst_acc_code: props.transaction_data?.igst_acc_code,
        sgst_acc_code: props.transaction_data?.sgst_acc_code,
        cgst_acc_code: props.transaction_data?.cgst_acc_code,
        cess_acc_code: props.transaction_data?.cess_acc_code,
      };
      const form = document.createElement("form");
      form.method = "POST";
      form.action = props.transaction_data?.returnurl;

      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = "resjson";
      hiddenField.value = props.transaction_data?.resjson;
      form.appendChild(hiddenField);
      document.body.appendChild(form);
      form.submit();
    }, 10000);

    return () => clearTimeout(timer);
  }, [props.transaction_data]);
  const progressWidth = `${(countdown / initialCountdown) * 100}%`;

  return (
    <div className="success-error-container">
      <Card className="success-error-card-width">
        <div className="countdown-timer">
          <span className="redirecting-in">Redirecting in:</span>
          <span className="timer-countdown">{`00:${
            countdown < 10 ? `0${countdown}` : countdown
          }`}</span>
        </div>
        <div className="progress-bar-container">
          <div className="progress-bar" style={{ width: progressWidth }} />
        </div>

        <div style={{ marginTop: "30px" }}>
          <img
            className="success-icon"
            src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/pending.svg"
            alt="Success Icon"
          />
        </div>
        <div className="pending-text">Payment Pending</div>
        <div className="generated-success-text">
          Generated on : {moment().format("DD/MM/YYYY, h:mm A")}
        </div>
        <br></br>
        <br></br>
        <Card className="success-descriptions-background-color">
          <Descriptions
            column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
            colon={false}
            labelStyle={{
              backgroundColor: "",
              borderRadius: "12px",
              color: "#000000",
              fontWeight: "500",
              width: "50%",
              marginBottom: "4px",
            }}
            contentStyle={{
              backgroundColor: "",
              borderRadius: "12px",
              color: "#000000",
            }}
            className="mobile-sequence"
          >
            <Descriptions.Item label="Transaction ID :" className="item item-1">
              {props?.transaction_data?.txnid || "---"}
            </Descriptions.Item>
            <Descriptions.Item label="GSTIN :" className="item item-3">
              {props?.transaction_data?.GSTIN || "---"}
            </Descriptions.Item>
            <Descriptions.Item label="CPIN :" className="item item-5">
              {props?.transaction_data?.CPIN || "---"}
            </Descriptions.Item>
            <Descriptions.Item label="State :" className="item item-7">
              {props?.transaction_data?.State || "---"}
            </Descriptions.Item>
            <Descriptions.Item label="IGST Amount :" className="item item-9">
              {props?.transaction_data?.IGST_Amount
                ? `₹ ${props.transaction_data.IGST_Amount}`
                : "---"}
            </Descriptions.Item>
            <Descriptions.Item label="CGST Amount :" className="item item-2">
              {props?.transaction_data?.CGST_Amount
                ? `₹ ${props.transaction_data.CGST_Amount}`
                : "---"}
            </Descriptions.Item>
            <Descriptions.Item label="SGST Amount :" className="item item-4">
              {props?.transaction_data?.SGST_Amount
                ? `₹ ${props.transaction_data.SGST_Amount}`
                : "---"}
            </Descriptions.Item>
            <Descriptions.Item label="CESS Amount :" className="item item-6">
              {props?.transaction_data?.CESS_Amount
                ? `₹ ${props.transaction_data.CESS_Amount}`
                : "---"}
            </Descriptions.Item>
            <Descriptions.Item label="Total Amount :" className="item item-8">
              {props?.transaction_data?.Amount
                ? `₹ ${props.transaction_data.Amount}`
                : "---"}
            </Descriptions.Item>
            <Descriptions.Item label="" className="item item-10">
              {""}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
            colon={false}
            labelStyle={{
              backgroundColor: "",
              borderRadius: "12px",
              color: "#000000",
              fontWeight: "500",
              width: "50%",
              marginBottom: "4px",
            }}
            contentStyle={{
              backgroundColor: "",
              borderRadius: "12px",
              color: "#000000",
            }}
            className="mt-4 desktop-sequence"
          >
            <Descriptions.Item label="Transaction ID :" className="item item-1">
              {props?.transaction_data?.txnid || "---"}
            </Descriptions.Item>
            <Descriptions.Item label="CGST Amount :" className="item item-2">
              {props?.transaction_data?.CGST_Amount
                ? `₹ ${props.transaction_data.CGST_Amount}`
                : "---"}
            </Descriptions.Item>
            <Descriptions.Item label="GSTIN :" className="item item-3">
              {props?.transaction_data?.GSTIN || "---"}
            </Descriptions.Item>
            <Descriptions.Item label="SGST Amount :" className="item item-4">
              {props?.transaction_data?.SGST_Amount
                ? `₹ ${props.transaction_data.SGST_Amount}`
                : "---"}
            </Descriptions.Item>
            <Descriptions.Item label="CPIN :" className="item item-5">
              {props?.transaction_data?.CPIN || "---"}
            </Descriptions.Item>
            <Descriptions.Item label="CESS Amount :" className="item item-6">
              {props?.transaction_data?.CESS_Amount
                ? `₹ ${props.transaction_data.CESS_Amount}`
                : "---"}
            </Descriptions.Item>
            <Descriptions.Item label="State :" className="item item-7">
              {props?.transaction_data?.State || "---"}
            </Descriptions.Item>
            <Descriptions.Item label="Total Amount :" className="item item-8">
              {props?.transaction_data?.Amount
                ? `₹ ${props.transaction_data.Amount}`
                : "---"}
            </Descriptions.Item>
            <Descriptions.Item label="IGST Amount :" className="item item-9">
              {props?.transaction_data?.IGST_Amount
                ? `₹ ${props.transaction_data.IGST_Amount}`
                : "---"}
            </Descriptions.Item>
            <Descriptions.Item label="" className="item item-10">
              {""}
            </Descriptions.Item>
          </Descriptions>
        </Card>

        <br></br>
        <Card className="pending-descriptions-payment-mode-background-color">
          <Descriptions
            column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
            colon={false}
            layout="vertical"
            labelStyle={{
              backgroundColor: "",
              borderRadius: "12px",
              color: "#000000",
              fontWeight: "500",
              marginBottom: "4px",
            }}
            contentStyle={{
              backgroundColor: "",
              borderRadius: "12px",
              color: "#000000",
              marginTop: "-10px",
            }}
            className=""
          >
            <Descriptions.Item label="Status">
              {" "}
              {toSentenceCase(props?.transaction_data?.status || "---")}{" "}
            </Descriptions.Item>
            <Descriptions.Item label="Payment Mode">
              {(props?.transaction_data?.type || "---").toUpperCase()}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Card>
    </div>
  );
};

export default PendingComponent;
